import { createSelector } from "reselect";
const pdfSelector = (state) => state.pdf;
const singleJobPdfSelector = (state, id) => ({
    state: pdfSelector(state),
    id
});
const getPdfJobs = createSelector(pdfSelector, (pdf) => pdf.jobs);
const getSingleJob = createSelector(singleJobPdfSelector, (singleJobPdf) => singleJobPdf.state.jobs.find(job => job.id === singleJobPdf.id));
const getPagination = createSelector(pdfSelector, (pdf) => {
    const { jobs, ...pagination } = pdf;
    return pagination;
});
const getPageSize = createSelector(pdfSelector, (pdf) => {
    const { pageSize } = pdf;
    return pageSize ? pageSize : 10;
});
const getFilters = createSelector(pdfSelector, (pdf) => pdf.filters);
const getOrdering = createSelector(pdfSelector, (pdf) => pdf.ordering);
const getLoadingStatus = createSelector(pdfSelector, (pdf) => pdf.isLoading);
export { getPdfJobs, getPagination, getSingleJob, getPageSize, getFilters, getOrdering, getLoadingStatus };
